import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
  import createJobStatusSetting from "@/types/requests/createJobStatusSetting"
  import createJobStatusFilterItems from "@/types/requests/createJobStatusFilterItems"
  import Api from "@/services/api/ApiServiceFabrick";
  import { useAuth } from "@/services/user/Auth0UserProvider"

  type Props = {
    showable: boolean;
    btnClass?: string;
    btnName?: string;
    type: string;
    operationOfficeId?: number;
    settings?: createJobStatusSetting;
    filterItems?: createJobStatusFilterItems;
    trips?: string[];
    disabled?: boolean;
    deliveryPlans?: Array<any>;
    addRequestParams?: (params) => any;
  };

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadButton',
  props: {
    showable: { type: Boolean, default: false },
    btnClass: {},
    btnName: {},
    type: {},
    operationOfficeId: {},
    settings: {},
    filterItems: {},
    trips: {},
    disabled: { type: Boolean, default: false },
    deliveryPlans: {},
    addRequestParams: { type: Function, default: (params) => { return params } }
  },
  setup(__props: any) {

  const { loginWithRedirect } = useAuth();
  const downloading = ref<boolean>(false);
  const localDeliveryPlans = ref<any>({ delivery_plan_ids: [] });

  const props = __props;

  const downloadFile = () => {
    downloading.value = true;

    let params = {
      operation_office_id: props.operationOfficeId ?? null,
      type: props.type,
      settings: props.settings ?? null,
      filter_items: props.filterItems ?? null,
      trips: props.trips ?? [],
    }
    params = props.addRequestParams(params)

    Api().createJobStatus(params).then((data) => {
      pollingJobStatus(data.id)
    }).catch((error) => {
      const res = error.response
      switch (res.status) {
        case 401:
          loginWithRedirect({ appState: { targetUrl: location.pathname } })
          break
        case 403:
          location.reload()
          break
        case 422:
      }
      downloading.value = false
    })
  }

  const pollingJobStatus = (id: number) => {
    const interval = setInterval(() => {
      Api().getJobStatus(id).then((res) => {
        if (res.status == "completed") {
          download(res.file_path)
          clearInterval(interval)
          downloading.value = false
        }
        if (res.status == "failed") {
          alert(res?.output_contents?.message)
          clearInterval(interval)
          downloading.value = false
        }
      })
    }, 3000)
  }

  const download = (path: string | null) => {
    if (!path) return;

    Api().fileDownload(path)
  }

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
    class: _normalizeClass([__props.btnClass, "file-download-btn"]),
    onClick: downloadFile,
    loading: downloading.value,
    style: _normalizeStyle({
      backgroundColor : __props.disabled ? '#B3B8BB' : ''
    }),
    disabled: __props.disabled
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.btnName), 1)
    ]),
    _: 1
  }, 8, ["class", "loading", "style", "disabled"])), [
    [_vShow, __props.showable]
  ])
}
}

})